export default __webpack_public_path__ + "static/media/search-empty-state.a735fb99.svg";